import { ABOUT, PROPERTY_NAME } from '../../../utils/constants';
import logo from '../../../assets/imgs/hotel_peristil_white.svg';

const About = () => {
  return (
    <div id={ABOUT} className='about'>
      <div className='about_container container'>
        <div className='about_container_text'>
          <h2 data-aos='fade-up' className='title_underline_light'>
            HOTEL PERISTIL
          </h2>
          <p data-aos='fade-up' data-aos-delay='50'>
            Welcome to Hotel Peristil!
          </p>
          <p data-aos='fade-up' data-aos-delay='100'>
            Our staff is doing our best to make your stay in our hotel
            memorable.
          </p>
          <p data-aos='fade-up' data-aos-delay='150'>
            If you need any kind of information about your stay or help with
            planning your itinerary, please do not hesitate to ask us at our
            front desk or contact us by phone or e-mail.
          </p>
        </div>
        <div className='about_container_logo'>
          <div
            data-aos='fade-up'
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <img src={logo} alt={PROPERTY_NAME + ' large logo'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
